import subMonthAdjust from './subMonthAdjust'
export default {
  components: { subMonthAdjust },
  data() {
    return {
      subMonthAdjustVisible: false
    }
  },
  methods: {
    showsubMonthAdjust(row, key) {
      this.rowData = row;
      this.rowData['editKey'] = key;
      this.subMonthAdjustVisible = true;
    }
  }
}